import { reportPeriods } from "@/consts/reportPeriods";

export default {
  name: "PrintableCalendarToolbar",
  props: {
    isLoadingReportPrint: {
      type: Boolean
    },
    printReportPeriod: {
      type: Number
    },
    isReport360ViewDataLoaded: {
      type: Boolean
    },
    isReport360ViewMediaDataLoaded: {
      type: Boolean
    },
    isReport360ViewServicesDataLoaded: {
      type: Boolean
    },
    isReport360ViewEventsDataLoaded: {
      type: Boolean
    },
    isPdfGenerating: {
      type: Boolean
    }
  },
  data(){
    return {
      periods: reportPeriods
    }
  },
  computed: {
    isReportLoading() {
      return !this.isReport360ViewDataLoaded || !this.isReport360ViewMediaDataLoaded 
      || !this.isReport360ViewServicesDataLoaded || !this.isReport360ViewEventsDataLoaded
    }
  },
  methods: {
    generatePdf() {
      this.$emit('generatePdf');
    },
    closePrintableReport() {
      this.$emit('closePrintableReport')
    },
    onChangeReportPeriod(value){
      this.$emit('onChangePrintReportPeriod', value)
    }
  }
}